export default __webpack_public_path__ + "static/media/doctor5.a3d79dc8.jpg";